import { useEffect, useState } from "react";
import ReactPhoneInput from "react-phone-number-input";
import { isValidPhoneNumber, E164Number } from "libphonenumber-js";
import { InputProps } from "./Input"; // Adjust this import path as needed
import "react-phone-number-input/style.css";

interface PhoneInputProps extends InputProps {
  country?: string; // Expecting values like "canada", "usa", etc.
  onValidityChange?: (valid: boolean) => void;
}

// Map full country names to ISO Alpha-2 codes
const mapCountryToISO = (country?: string): "CA" | "US" => {
  switch ((country || "").toLowerCase()) {
    case "canada":
      return "CA";
    case "usa":
    case "us":
      return "US";
    default:
      return "CA"; // fallback to US if unknown
  }
};

function PhoneInput(props: PhoneInputProps) {
  const [value, setValue] = useState<string | E164Number | undefined>(props.value);
  const [isValid, setIsValid] = useState(true);

  const defaultCountry = mapCountryToISO(props.country);

  // Validate and call onSubmit
  // useEffect(() => {
  //   if (value) {
  //     const valid = isValidPhoneNumber(value);
  //     setIsValid(valid);
  //     props.onSubmit(value as string);
  //   } else {
  //     setIsValid(true);
  //   }
  // }, [value]);

  useEffect(() => {
    if (value) {
      const valid = isValidPhoneNumber(value);
      setIsValid(valid);
  
      if (props.onValidityChange) {
        props.onValidityChange(valid); 
      }
  
      props.onSubmit(value as string);
    } else {
      setIsValid(true);
  
      if (props.onValidityChange) {
        props.onValidityChange(true); 
      }
    }
  }, [value]);

  // Update value from parent
  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <div className="max-w-md">
      <ReactPhoneInput
        id="phone"
        placeholder="Enter phone number"
        value={value}
        onChange={setValue}
        defaultCountry={defaultCountry}
        className={`w-full p-2 border ${
          isValid ? "border-gray-300" : "border-red-500"
        } rounded-md focus:ring-primary focus:border-primary`}
      />
      {!isValid && (
        <p className="text-sm text-red-600 mt-1">Invalid phone number</p>
      )}

      {/* Optional Custom Styling */}
      <style>{`
        .PhoneInputInput {
          flex: 1;
          min-width: 0;
          height: 40px;
          padding-left: 0.5rem;
          border: none;
          outline: none;
        }
        .PhoneInputCountry {
          position: relative;
          align-self: stretch;
          display: flex;
          align-items: center;
          background-color: #f3f4f6;
          padding: 0 0.5rem;
          border-radius: 0.375rem 0 0 0.375rem;
        }
      `}</style>
    </div>
  );
}

export default PhoneInput;
